module.exports = __webpack_public_path__ + "img/project9_7.png.9d40dab2.webp";